export const RFInitialValues = {
  searchType: '0',
  searchValue: '',
  dateFilter: '0',
  categ: {
    individuals: true,
    solidarityGroups: true,
    companies: true,
  },
  safety: {
    insured: 0,
    watched: 0,
    blacklisted: 0,
  },
  tagsDisabled: true,
  tagId: 1,
}

export const formName = 'frm_client_list'
export const objectName = 'dbgrd_clients'
